export const UTILITIES = {
  EDENOR: 'edenor',
  EDELAP: 'edelap',
  EDEN: 'eden',
  EDES: 'edes',
  EDESA: 'edesa',
  EDEA: 'edea'
};
